// import external dependencies
import 'jquery';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'slick-carousel/slick/slick.min';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,

  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Detect and Remove Date Picker Autofill
$('.gfield .datepicker').each(function () {
  $(this).attr('autocomplete', 'off');
});

// Header Menu
const menu = document.querySelector('#header-left-wrapper');
const menuItems = document.querySelectorAll('.menuItem');
const hamburger = document.querySelector('.hamburger');
const closeIcon = document.querySelector('.closeIcon');
const menuIcon = document.querySelector('.menuIcon');
const headerBottom = document.querySelector('.header__bottom');
const body = document.body;

function toggleMenu() {
  if (menu.classList.contains('showMenu')) {
    menu.classList.remove('showMenu');
    closeIcon.style.display = 'none';
    menuIcon.style.display = 'block';
    headerBottom.style.display = 'block';
    body.style = '';
  } else {
    menu.classList.add('showMenu');
    closeIcon.style.display = 'block';
    menuIcon.style.display = 'none';
    headerBottom.style.display = 'none';
    body.style = 'overflow: hidden;height: 100vh;';
  }
}

hamburger.addEventListener('click', toggleMenu);

menuItems.forEach(
  function (menuItem) {
    menuItem.addEventListener('click', toggleMenu);
  }
);

// Scroll
var i = 0;
$('#hero-scroll').on('click', function(e) {
  e.preventDefault();
  i++;
  var offset = $('section').eq(i).offset().top;
  $('html, body').stop().animate({
    scrollTop: offset,
  }, 400);
});



// WEBPACK FOOTER //
// ./scripts/main.js